import "./Footer.css"
const Footer = () => {
    return (
        <div>
        <div className="footer">
            <div className="footer-one">
                <div className="footer-text">
                    Copyright © 2019
                </div>
                <div className="footer-text">
                    Hodlinfo.com
                </div>
                <div className="footer-text">
                    Developed By <span>QuadBtech</span>
                </div>
            </div>
            <div className="footer-text">
                    Support
                </div>
        </div>
        <div className="nothing"></div>
        </div>
      );
}
 
export default Footer;